import * as React from "react";
import * as ReactDOM from "react-dom";
import { clientAppSettings } from "../../Models/ClientAppSettings";
import { MessageBox } from "../../Dialogs/MessageBox";
import { ProgressDialog } from "../../Dialogs/ProgressDialog";
import { TermsOfServiceDialog } from "../../Dialogs/TermsOfServiceDialog";
import { TermsOfServiceDialogProps } from "./TermsOfServiceDialog";
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";

import { CultureUtility } from '../../Resources/CultureUtility';

// tslint:disable
import * as $ from "jquery";
type AjaxSettings = JQueryAjaxSettings;
type AjaxPromise<T> = JQueryPromise<T>;
const innerAjax = $.ajax;
const extend = $.extend;
/** Optionally, set this variable to your network activity indicator function. */
export var showNetworkIcon = (show: boolean) => { };

/** Optionally, set this to your own ajax function. */
export var ajax: (settings: AjaxSettings) => AjaxPromise<any> = _ajax;

/** Optionally, set this to a string that all urls should be prefixed with. */
export var urlPrefix = '';

/** Optionally, set this to additional header key/value pairs to send along with ajax requests. */
export var ajaxHeaders: { [key: string]: any } = null;

/** Wraps ajax function and adds network activity indicator. */
function _ajax(settings_: AjaxSettings): AjaxPromise<any> {
    var settings: AjaxSettings = extend({}, settings_, { url: urlPrefix + settings_.url });
    if (settings.data)
        settings.contentType = 'application/json';
    if (ajaxHeaders)
        settings.headers = ajaxHeaders;
    showNetworkIcon(true);
    return innerAjax(settings).always(() => showNetworkIcon(false));
}
// // tslint:enable

export interface BotChannelConfigProps extends React.Props<BotChannelConfig> {
    currentBotId: string;
    channel: string;
    channelConfigInterface: ChannelConfigInterface;
    azureToken: string;
}

export interface BotChannelConfigState{
    body: string,
    showProgressMask: boolean
}

export interface ChannelConfigInterface {
    leaveChannelConfig: () => void;
    reloadBot: () => void;
    showDeleteDialog?: (callback) => void;
    showConfirmLeaveDialog?: (callback) => void;
    showProgressDialog?: (message: string) => ProgressDialog;
    showTosDialog?: (checkbox: string, successCallback, failCallback) => void;
}

export class BotChannelConfig extends React.Component<BotChannelConfigProps, BotChannelConfigState> {
    constructor(props) {
        super(props);

        const configInterface: ChannelConfigInterface = props.channelConfigInterface;
        _.defaults(configInterface, {
            showDeleteDialog: this.deleteDialog,
            showConfirmLeaveDialog: this.leaveDialog,
            showProgressDialog: ProgressDialog.show,
            showTosDialog: this.tosDialog
        });
        window["channelConfigInterface"] = props.channelConfigInterface;
        this.state = {
            body: "",
            showProgressMask: false
        };
    }

    private deleteDialog(callback: () => void, _lastNode?: React.ReactInstance) {
        const mb = new MessageBox({
            okButtonClass: "m-button-destructive-outline-md",
            okButtonLabel: Resources.channelConfigDeleteOk,
            cancelButtonLabel: Resources.channelConfigDeleteCancel
        });
        mb.message = Resources.channelConfigDeleteMessage;
        mb.header = Resources.channelConfigDeleteHeader;
        return mb.showDialog(_lastNode).done(callback);
    }

    private leaveDialog(callback: () => void) {
        const mb = new MessageBox({
            okButtonLabel: Resources.channelConfigLeaveOk,
            cancelButtonLabel: Resources.channelConfigLeaveCancel
        });
        mb.message = Resources.channelConfigLeaveMessage;
        mb.header = Resources.channelConfigLeaveHeader;
        return mb.showDialog().done(callback);
    }

    private tosDialog(checkbox: string, successCallback: () => void, fail: () => void) {
        const tosDialogProps: TermsOfServiceDialogProps = {
            header: Resources.tosDialog_Header,
            message: Resources.tosDialog_MessageChannels,
            checkboxes: [checkbox]
        }
        let termsDialog = new TermsOfServiceDialog(tosDialogProps);
        return termsDialog.showDialog().done(successCallback).fail(fail);
    }

    public render(): JSX.Element {
        const rootPath = clientAppSettings.applicationPath === '/' ? '' : clientAppSettings.applicationPath;
        const url = `${rootPath}/channels/${this.props.channel}/${this.props.currentBotId}`;

        // Build the query string based on the current culture and if we are in the Ibiza Azure blade.
        const query = { };
        if (CultureUtility.rawLocale) {
            query["l"] = CultureUtility.rawLocale;
        }
        if (Environment.isInBotFrameworkAzureExtension) {
            query["ioenv"] = "ibiza";
        }
        
        const queryString = jQuery.param(query);
        const path = url + ((queryString) ? "?" + queryString : "");

        if(this.props.channel == "directlinespeech")
        {
            BotChannelConfig.getDLSChannelPage(
                path,
                this.props.azureToken).done(
                    (body) => {
                        if(this.state.body === "")
                        {
                            this.setState({ body: body });
                        }
                    }
                ).fail(
                    () => {
                        if(this.state.body === "")
                        {
                            this.setState({ body: "<html><body><p>Something went wrong.</p><body></html>" });
                        }
                    }
                )
            
            return (<div className="channel-config-wrapper">
            <iframe title="Channel Configuration" className="channel-config-iframe" srcDoc={this.state.body}></iframe>
            </div>);;
        }
        else
        {
            return <div className="channel-config-wrapper">
            <iframe title="Channel Configuration" className="channel-config-iframe" src={path}>
            </iframe>
        </div>;
        }

    }

    /** Get DLS channel page */
    private static getDLSChannelPage(url: string, azureToken: string): AjaxPromise<string> {
        return ajax({
            dataType: 'html',
            url: url,
            type: 'GET',
            headers: { 'azureToken': azureToken },
        });
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotChannelConfig.tsx